var _path, _path2, _path3, _circle, _rect, _path4, _path5, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDpoOpen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M44.36 15.58a.77.77 0 0 1-.5-.18l-4.52-3.64a.8.8 0 1 1 1-1.24l3.9 3.13 3.11-3.91a.82.82 0 0 1 1.13-.13.81.81 0 0 1 .12 1.13L45 15.28a.83.83 0 0 1-.54.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M44.42 14.5a.81.81 0 0 1-.79-.65c-1.26-6.62-5-8.67-7.82-9.22-4.09-.79-8.18 1-9.22 2.66a.8.8 0 0 1-1.34-.86c1.48-2.3 6.31-4.25 10.86-3.37 2.75.53 7.58 2.6 9.09 10.49a.79.79 0 0 1-.63.93ZM27.74 41.76H2.35A1.74 1.74 0 0 1 .61 40V14.63a1.74 1.74 0 0 1 1.74-1.74h25.39a1.74 1.74 0 0 1 1.73 1.74V40a1.74 1.74 0 0 1-1.73 1.76ZM2.35 14.49a.14.14 0 0 0-.14.14V40a.14.14 0 0 0 .14.14h25.39a.13.13 0 0 0 .13-.14V14.63a.13.13 0 0 0-.13-.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M22.5 32a.79.79 0 0 1-.62-.3l-4.21-5.24c-1 1.15-2.74 3.25-3 3.5a.8.8 0 0 1-1.13.08l-1.42-1.23-2.31 2.86a.8.8 0 1 1-1.24-1l2.87-3.53a.77.77 0 0 1 .55-.29.81.81 0 0 1 .59.19L14 28.28l3.06-3.62a.8.8 0 0 1 1.23 0l4.81 6a.8.8 0 0 1-.6 1.34Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.72,
    cy: 23.42,
    r: 1.33,
    fill: "#0039a6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.81,
    height: 38.81,
    x: 23.78,
    y: 21.55,
    fill: "#fff",
    rx: 1.33
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M61.26 61.16H25.12A2.13 2.13 0 0 1 23 59V22.89a2.13 2.13 0 0 1 2.13-2.13h36.13a2.13 2.13 0 0 1 2.13 2.13V59a2.14 2.14 0 0 1-2.13 2.16ZM25.12 22.35a.54.54 0 0 0-.54.54V59a.54.54 0 0 0 .54.53h36.14a.53.53 0 0 0 .53-.53V22.89a.54.54 0 0 0-.53-.54Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0039a6",
    d: "M53.8 47.23a.79.79 0 0 1-.62-.3l-6.24-7.78-4.48 5.3a.81.81 0 0 1-1.13.08l-2.29-2-3.56 4.38a.8.8 0 1 1-1.24-1l4.08-5a.75.75 0 0 1 .55-.29.8.8 0 0 1 .59.19l2.31 2c1.32-1.55 4.57-5.41 4.57-5.41a.82.82 0 0 1 .66-.3.79.79 0 0 1 .61.3l6.85 8.53a.8.8 0 0 1-.13 1.12.77.77 0 0 1-.53.18Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.61,
    cy: 35.4,
    r: 1.9,
    fill: "#0039a6"
  })));
};
export default SvgIconDpoOpen;